import axios from 'axios'
import React, { useEffect, useMemo, useRef, useState, useCallback, startTransition } from 'react'
import { useDndAutoScroll } from '../../../../../generic/hooks/useDndAutoScroll'
import {
    DndContext,
    DragOverlay,
    MeasuringStrategy,
    MouseSensor,
    TouchSensor,
    KeyboardSensor,
    useDroppable,
    useSensor,
    useSensors,
    closestCorners,
    pointerWithin,
} from '@dnd-kit/core'
import {
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
    arrayMove,
} from '@dnd-kit/sortable'
import { useDispatch, useSelector } from 'react-redux'
import { LOAD, LOAD_END, LOGOUT, SELECT_TEUDA_TITLE } from '../../../../../../store/actions/actionsTypes'
import DatePickerModule from '../../../../../generic/datePicker/datePicker'
import Title from '../../../../../generic/Title/Title'
import { CREATE_TEUDOT, EDIT_ORDER_ROW, GET_CAR_ARIZOT, GET_CUSTOMER_GROUP, GET_CUSTOMER_LIST, GET_DELIVERYCODES, GET_ORDER, GET_PRODUCT_TYPES, GET_TEUDOT, LOAD_ORDERS } from '../../../../../modules/API/settings'
import { BodyContainer, BodyGroupContainer, BodyGroupContentWrapper, BodyGroupTitleWrapper, IconWrapperOrdersSecond, SectionMain, SectionMainContainer } from '../likutWorkers/LikutSetWorkers'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import styled from 'styled-components'
import ArrowIcon from '../../../../../generic/icons/IconLib/ArrowIcon'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import ErrorIcon from '../../../../../generic/icons/IconLib/AlertCircleIcon'
import FilterIcon from '../../../../../generic/icons/IconLib/FilterIcon'
import ReloadIcon from '../../../../../generic/icons/IconLib/RefreshIcon'
import SettingMiksher from '../../../../../generic/icons/IconLib/SlidersIcon'
import FilterModal from './FilterModal'
import { updateStatusAzmana } from '../../../../../modules/requests/updateAzmanaStatus'
import { addIDForTheList } from '../../../../../generic/utils/addUIDForTheList'
import OrderGetheringItemWithDetailes from '../../../../../generic/cards/OrderGethering/OrderGetheringItemWithDetailes'
import { passOrderRowsIntoOrder, passOrderRowsIntoOrderByWeight, passTeudotIntoOrder } from '../../../../../generic/utils/passOrderRowsIntoOrder.js'
import { getOverweightFactor } from '../../../../../generic/utils/overweight'
import SelectWorkerModal from './SelectWorkerModal'
import { ButtonWrapper, FilterIndicator, HeadWrapper } from '../../trucks/TrucksMain'
import { statusAzmanotList } from '../../../../../generic/artcoded/statusAzmanot'
import SelectOrderToShow from './SelectOrderToShow'
import selectBrodMigdal from '../../../../../generic/utils/selectBrodMigdal'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import SelectDriver from '../../trucks/SelectDriver'
import { Certificates } from '../../../../../modules/API/Certificates/certificates'
import RemarkModal from '../../arizot/View/RemarkModal'
import { Orders } from '../../../../../modules/API/Orders/orders'
import { Pallets } from '../../../../../modules/API/Pallets/pallets'
import PalletDetaileModal from './PalletDetailes/PalletDetaileModal'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { filterOrdersByWarehouse, getDefaultWarehouseID, resolveTeudaTranzit } from '../helpers/likutListHelpers'
import { useBrodMigdal } from '../../../../../generic/hooks/useBrodMigdal'
import { Defaults } from '../../../../../modules/API/Defaults/defaults'
import useConfigLefiMishkal from '../useConfigLefiMishkal'
import PackagePalletSummaryModal from '../Components/PackPallet/PackagePalletSummaryModal'
import { useNavigate } from 'react-router-dom'
import { LINKS } from '../../../../../Routs/config'
import OrderStatusLogModal from '../../orders/Components/OrderStatusLogModal'
import { PalletLogModal } from '../../../../../generic/modals/PalletLogModal'
import usePrint from '../../../../../generic/hooks/usePrint'
import { AppModal } from '../../../../../generic/ui/Modal'
import { PdfPreview } from '../../../../../generic/ui/PdfPreview'
import { Printouts } from '../../../../../modules/API/Printouts/printouts'
import { Workers } from '../../../../../modules/API/Workers/workers'
import WorkerHistoryModal from './Components/WorkerHistoryModal'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'

export const BodyContainerCustom = styled(BodyContainer)`
    border-radius: 30px;
    position: relative;
    overflow: auto;
    justify-content: flex-start;
    &::-webkit-scrollbar {
        height: 0;
    }
   
    `
export const BodyGroupContainerCustom = styled(BodyGroupContainer)`
   min-width: 380px;
    /* background: red; */
 user-select: none;
   display: ${props => props.$visible ? 'flex' : 'none'};
   
`

const ControlLeft = styled.div`
    position: absolute;
    background: red;
    height: 4em;
    width: 2em; 
    z-index: 4;
    left: 0; 
    top: calc(50% - 2em);
    display: ${props => props.$visible ? 'none' : 'flex'};
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
    color: #297f76;
    cursor: pointer;
    border-radius: 0 25% 44% 0 / 0 35% 24% 0;
    background: rgba(255,255,255,0.9);
`
const ControlRigth = styled.div`
    position: absolute;
    /* background: red; */
    height: 4em;
    width: 2em;
    z-index: 4;
    right: 0;
    top: calc(50% - 2em);
    display: ${props => props.$visible ? 'flex' : 'none'}  ;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
    color: #297f76;
    cursor: pointer;
    border-radius: 55% 0 0 44% / 35% 0 0 24%;
    background: rgba(255,255,255,0.9);
`
const ProblemIndicator = styled.div`
    position: absolute;
    top: -0.2em;
    right: -0.2em;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    background: tomato;
    display: ${props => props.$visible ? 'flex' : 'none'};
`

const ErrorWrapper = styled.div`
    position: absolute;
    right: -3.5em;
    top: .5em;
    background: tomato;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3em;
    height: 3em;
    border-radius: 50%;
    color: #fff;
`

// pointerWithin follows the actual cursor, so an empty column under the
// pointer is hit even when the dragged overlay's corners sit closer to a
// neighbour's cards. closestCorners stays as a fallback for the brief
// moments when the pointer is between droppables (gap, scrollbar lane).
const monitoringCollisionDetection = (args) => {
    const pointerHits = pointerWithin(args)
    if (pointerHits.length > 0) return pointerHits
    return closestCorners(args)
}

const SortableColumn = ({ id, items, isAllowDrop, children }) => {
    const { setNodeRef } = useDroppable({ id })
    const itemIds = items?.map((item, idx) => item.OrderID?.toString() ?? `${id}-${idx}`) || []
    return (
        <SortableContext id={id} items={itemIds} strategy={verticalListSortingStrategy}>
            <BodyGroupContentWrapper ref={setNodeRef} $isAllowDrop={isAllowDrop}>
                {children}
            </BodyGroupContentWrapper>
        </SortableContext>
    )
}

const MonitoringColumn = React.memo(function MonitoringColumn({
    id, title, items, isAllowDrop, visible, columnRef,
    customersDict, workersList, deliveryCodes, isWeightCalculation,
    selectIconForPalletType, selectProductForRemark,
    handleOpenOrderStatusLogModal, handleOpenWorkerHistoryModal,
    actionFunc, handlePalletDetailsModal,
    selectTeudaFunc, handleOpenPalletLogModal,
}) {
    return (
        <BodyGroupContainerCustom $visible={visible} ref={columnRef}>
            <BodyGroupTitleWrapper>
                {title}
                <IconWrapperOrdersSecond>{items?.length}</IconWrapperOrdersSecond>
            </BodyGroupTitleWrapper>
            <SortableColumn id={id} items={items} isAllowDrop={isAllowDrop}>
                {items?.map((item, index) => (
                    <OrderGetheringItemWithDetailes
                        {...item}
                        key={item.OrderID}
                        item={item}
                        index={index}
                        Color={customersDict[item.CustomerID]?.Color || '#000'}
                        isWeightCalculation={isWeightCalculation}
                        workersList={workersList}
                        deliveryCodes={deliveryCodes}
                        selectIconForPalletType={selectIconForPalletType}
                        selectProductForRemark={selectProductForRemark}
                        handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                        handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                        actionFunc={actionFunc}
                        handlePalletDetailsModal={handlePalletDetailsModal}
                        selectTeudaFunc={selectTeudaFunc}
                        handleOpenPalletLogModal={handleOpenPalletLogModal}
                    />
                ))}
            </SortableColumn>
        </BodyGroupContainerCustom>
    )
})

export default function MonitoringMain() {
    const defaults = useSelector(e => e.defaults?.defaults)
    const defaultsTable = useSelector(e => e.defaults?.tableOfTables)
    const { transportAreas } = useSelector(e => e.defaults)
    const transportAreaDict = transportAreas?.dict
    const navigate = useNavigate()
    const isHovaRehev = selectBrodMigdal(defaults, 340, 'Logical_Value')
    const defaultCarID = selectBrodMigdal(defaults, 427, 'Num_Value')
    const { getBrodMigdal } = useBrodMigdal()
    const [tempTeudaData, setTempTeudaData] = useState({})
    const [isOpenSelectDriver, setIsOpenSelectDriver] = useState(false)
    const [carsInfo, setCarsInfo] = useState([])

    const patchDriver = async (id, func) => {
        let tempObj = {
            ...tempTeudaData.dataForTeuda,
            "Vehicle_Code": id
        }
        try {
            let fetchTeuda = await createTeuda(tempObj)
            setAzmanotList(tempTeudaData.curOrdersList)
            setAzmanotListDefault(tempTeudaData.defOrdersList)
            cancelFuncTeudot(true)
        } catch (err) {
            console.log(err)
            cancelFuncTeudot()
            handleNotifications(err?.response?.data?.message ?? err?.message ?? String(err), { type: 'error' })
        }
    }

    const cancelFuncTeudot = (flag) => {
        setIsOpenSelectDriver(false);
        if(flag) return
        let tempArr = azmanotListDefault.map(item => {
            if(item.OrderID === tempTeudaData.dataForTeuda.OrderNum) {
                item.Status = 4
            }
            return item
        })
        listSetter(tempArr)
    }
    
    const scrollRef = useRef(null);
    const [droppbleAreas, setDroppbleAreas] = useState([])
    const [activeItem, setActiveItem] = useState(null)
    const [isDragActive, setIsDragActive] = useState(false)
    const dragSnapshotRef = useRef(null)
    const dragSourceColRef = useRef(null)
    const lastCrossColMoveRef = useRef(0)
    const monitoringScrollRef = useRef(null)

    useDndAutoScroll(monitoringScrollRef, {
        enabled: isDragActive,
        threshold: 100,
        maxSpeed: 18,
        minIntervalMs: 20,
    })
    const [scrollFlag, setScrollFlag] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [teudot, setTeudot] = useState([]);
    const [azmanotList, setAzmanotList] = useState([]);
    const [azmanotListDefault, setAzmanotListDefault] = useState([]);
    const [detailsListDefault, setDetailsListDefault] = useState([]);

    const [siumLikutList, setSiumLikutList] = useState([]);
    const [closedList, setClosedList] = useState([]);
    const [likutList, setLikutList] = useState([]);
    const [filterFunc, setFilterFunc] = useState(null);
    const [siumInputValue, setSiumInputValue] = useState('')
    const [mishloahList, setMishloahList] = useState([]);
    const [ashlamotLikutList, setAshlamotLikutList] = useState([]);
    const ordersAll = useMemo(
        () => statusAzmanotList?.filter(e => [1, 3, 4, 7, 9]?.some(item => item === e.id)),
        []
    )
    const [visibleColumns, setVisibleColumns] = useState({
        1: true,
        3: true,
        4: true,
        7: true,
        9: true
    })

    // const [workersList, setWorkersList] = useState(null);
    const [deliveryCodes, setDeliveryCodes] = useState(null);
    const [prodTypes, setProdTypes] = useState(null);

    const [isOpenRemarkWindow, setIsOpenRemarkWindow] = useState(false);
    const [remarkWindowData, setRemarkWindowData] = useState(null);
    
    const handleRemarkModal = useCallback(() => {
        setIsOpenRemarkWindow(prev => !prev)
    }, [])
    const selectItemForRemark = useCallback((item) => {
        setRemarkWindowData(item)
        handleRemarkModal()
    }, [handleRemarkModal])
    // for filter
    // const [workerGroupList, setWorkerGroupList] = useState([]);

    const workerGroupList = useMemo(
        () => addIDForTheList(defaultsTable.filter(e => e.MainCode === 311 && e.SecondCode !== 0)),
        [defaultsTable]
    );
    const workerGroup = useMemo(
        () => reduceArrayForHashTable(workerGroupList, 'SecondCode', 'Description'),
        [workerGroupList]
    );
    const [deliveryCodeList, setDeliveryCodeList] = useState([]);
    const [customerList, setCustomerList] = useState([])

    const [isOpenOrderFilter, setIsOpenOrderFilter] = useState(false)
    const dispatch = useDispatch();
    const getToken = useSelector(token => token.mainReducer?.token);
    const {
        file: pdfFile,
        setPdfFromBlob,
        handleSharePdf,
        handleDownloadPdf,
        handleOpenPdf,
        handleClearFile: handleClearPdfFile,
    } = usePrint();
    const user = useSelector(token => token.mainReducer?.user);
    // Orders are filtered by the user's transit warehouse right away; 0 — all warehouses.
    const [warehouseID, setWarehouseID] = useState(() => getDefaultWarehouseID(user?.tranzit));
    const { data: warehouseList } = useDataFetcher(Defaults.getWarhouseList, 'data');
    const defaultPackageList = useSelector(info => info.defaults.packageList);
    // WORKERS PART
    const workersArr = useSelector(list => list.defaults?.workerList);
    const workersList = useMemo(() => workersArr.reduce((acc, cur) => {
        acc[cur.WorkerId] = cur.WorkerName
        return acc
    }, {}), [workersArr])
    const [isOpenSelectWorker, setIsSelectWorker] = useState(false);
    const [isOpenPalletLogModal, setIsOpenPalletLogModal] = useState(false);
    const [selectedTeuda, setSelectedTeuda] = useState(null);
    const [selectedOrderForWorker, setSelectedOrderForWorker] = useState(null)

    // const isWeightCalculation = !selectBrodMigdal(defaults, 619, 'Logical_Value');
    const [isWeightCalculation, calcWeightPerUnit] = useConfigLefiMishkal()
    const [customerGroup, setCustomerGroup] = useState([]);
    const marketAreaList = useMemo(
        () => defaultsTable.filter(e => e.MainCode === 300 && e.SecondCode !== 0),
        [defaultsTable]
    )
    const isExistErrorRow = useMemo(
        () => azmanotListDefault?.some(item => item.detailes?.some(e => e.ChangeReason === 0 && e.SupplyQty > e.OrderPacks * getOverweightFactor(e.CollectDeviation))),
        [azmanotListDefault]
    );
    const customersDict = useMemo(() => customerList.reduce((acc, cur) => {
        acc[cur['CustomerID']] = cur
        return acc
    }, {}), [customerList])
    const [requestCounter, setRequestCounter] = useState(0)
    const handleModalOrders = () => {
        setIsOpenOrderFilter(!isOpenOrderFilter);
    }

    const handleOpenPalletLogModal = useCallback((teuda) => {
        setSelectedTeuda(teuda)
        setIsOpenPalletLogModal(true)
    }, [])
    const handleClosePalletLogModal = useCallback(() => {
        setIsOpenPalletLogModal(false)
        setSelectedTeuda(null)
    }, [])
    const selectIconForPalletType = useCallback((packID) => {
        if (!packID) return ''
        let filtered = defaultPackageList.filter(e => e?.PackID === packID)
        let result = filtered[0]?.Pack_Type
        return result
    }, [defaultPackageList])

    const listSetter = (flag) => {
        let azmanotWithDetails = flag ? flag : azmanotListDefault
        if (!flag) {
            for (let i in azmanotListDefault) {
                azmanotWithDetails[i].detailes = detailsListDefault[azmanotWithDetails[i]?.OrderID] || null
            }
        }
        let temp = reduceArrayForHashTable(azmanotWithDetails, "Status", false, 'arr')
        setSiumLikutList(temp[3] || []);
        setMishloahList(temp[4] || []);
        setAshlamotLikutList(temp[7] || []);
        setLikutList(temp[1] || [])
        setClosedList(temp[9]?.filter(e => e.teudot.length > 0) || [])
    }

    // With a warehouse selected an empty azmanotList means "no orders there", not "no filter applied".
    const searchSium = (input = siumInputValue, arr = ((azmanotList.length > 0 || warehouseID) ? azmanotList : azmanotListDefault)) => {
        const filtered = arr.filter(item =>
            item.OrderID.toString().toLowerCase().includes(input.toLowerCase()) ||
            item.Customer_Name.toLowerCase().includes(input.toLowerCase()) ||
            item.GroupDesc?.toLowerCase().includes(input.toLowerCase()) ||
            workersList[item.WorkerID]?.includes(input.toLowerCase()) ||
            workerGroup[item.PickupGroup]?.includes(input.toLowerCase()) ||
            deliveryCodes[item.Delivery_Code]?.includes(input.toLowerCase())
        )
        setSiumInputValue(input);
        listSetter(filtered)
    }
    const getCars = async () => {
        try {
            
            let res = await axios.get(GET_CAR_ARIZOT, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            
            setCarsInfo(res.data.cars.filter(e => e.Active))
        } catch (err) {
            console.log(err.response)
        }
    }
    const getProdTypes = async () => {
        try {
            let response = await axios.get(`${GET_PRODUCT_TYPES}`, {
                headers: {
                    Authorization: 'Bearer ' + getToken
                }
            })
            setProdTypes(response.data.productsGroups)

        } catch (err) {
            if (err.response.status !== 404) {
                handleNotifications(err.response.data.message, { type: 'error' })
                if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                    dispatch({ type: LOGOUT, payload: false });
                }
            }
        }
    }

    const getClients = async () => {
        try {
            let res = await axios.get(GET_CUSTOMER_LIST, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            setCustomerList(res.data.customers)
        } catch (err) {
            console.log(err.response)
        }
    }

    const getDeliveryCodes = async () => {
        try {
            let res = await axios.get(GET_DELIVERYCODES, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            setDeliveryCodeList(res?.data?.deliveryCodes)
            let table = reduceArrayForHashTable(res?.data?.deliveryCodes, 'Delivery_Code', 'Delivery_Description');
            setDeliveryCodes(table)
        } catch (err) {
            console.log(err)
        }
    }

    const changeStatusAzmana = async (num, status) => {
        try {   
            let res = await Orders.changeOrderStatusGo(num, status)
            updateStatusAzmana(num, user, status)

        } catch (err) {
            handleNotifications(err?.response?.data?.message ?? err?.message, { type: 'error' })
        }
    }

    const putWorkersAzmanot = async (workerId, object, action = '-') => {
        try {
            await Workers.updateWorkerOrders({
                "Action": action,
                'WorkerID': workerId,
                "Orders": [object]
            })
        } catch (err) {
            handleNotifications(err?.response?.data?.message ?? err?.message, { type: 'error' })
        }
    }

    const getAzmanot = async (startDate) => {
        dispatch({ type: LOAD })
        try {
            const res = await Orders.getOrdersWithDetails(startDate, '1,3,4,7,9')
            let teudot = await getTeudat(startDate)
            const hashDetails = isWeightCalculation ?
                passOrderRowsIntoOrderByWeight(res.OrderDetails) : 
                    passOrderRowsIntoOrder(res.OrderDetails)
            const teudotHash = passTeudotIntoOrder(teudot)
            let final = res.Orders.map(item => {
                item.detailes = hashDetails[item?.OrderID] || []
                item.teudot = teudotHash[item?.OrderID] || []
                return item
            })
            setAzmanotListDefault(final)
            setDetailsListDefault(hashDetails);
            if (!filterFunc) {
                const visible = filterOrdersByWarehouse(final, warehouseID)
                setAzmanotList(visible)
                listSetter(visible)
            }
            else {
                filterFunc.get(final)
            }
        } catch (err) {
            console.log(err.response)
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const getCustomerGroup = async () => {
        try {
            let res = await axios.get(GET_CUSTOMER_GROUP, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            setCustomerGroup(res.data.groups)
        } catch (err) {}
    }

    const getTeudat = async (startDate, endDate) => {
        // dispatch({ type: LOAD })
        try {
            let res = await axios.get(`${GET_TEUDOT}fromDate=${startDate}&toDate=${endDate ? endDate : startDate}`, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            let newArr = addIDForTheList(res.data.delivery)
            setTeudot(newArr)
            return newArr
        } catch (err) {
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        } finally {
            // dispatch({ type: LOAD_END })
        }
    }

    useEffect(() => {
        if (startDate.toString().length > 8) return
        getAzmanot(startDate);
    }, [startDate])

    useEffect(() => {
        getCustomerGroup();
        getProdTypes();
        getClients();
        getDeliveryCodes();
    }, [])

    const controlSelectWorkerBtn = useCallback((item) => {
        if (item) {
            setSelectedOrderForWorker(item)
            setIsSelectWorker(true)
        } else {
            setSelectedOrderForWorker(null)
            setIsSelectWorker(false)
        }
    }, [])
    const selectTeudaFunc = useCallback((item) => {
        dispatch({type: SELECT_TEUDA_TITLE, payload: item})
    }, [dispatch])
    const handleSaveWorker = (order, id, action = '+') => {
        putWorkersAzmanot(id, order, action).then(() => {
            const newArr = [...ashlamotLikutList]
            let found = newArr.indexOf(order)
            newArr[found] = {
                ...newArr[found],
                WorkerID: id
            }
            setAshlamotLikutList(newArr)
            controlSelectWorkerBtn()
        }).catch(err => {
            throw err
        })
    }
    const droppableAreasHelper = (sourceID) => {
        const dict = {
            'droppble5': ['droppble3'], // from teudot
            'droppble4': ['droppble3', 'droppble2', 'droppble1'], // from likut
            'droppble2': ['droppble3', 'droppble1'], // from sium likut
            'droppble3': ['droppble2', 'droppble1'], // from ashlamot
            'droppble1': ['droppble2', 'droppble3', 'droppble5'] // from mishloah
        }
        return dict[sourceID] || []
    }

    const getListByCol = (col) => {
        switch (col) {
            case 'droppble1': return mishloahList
            case 'droppble2': return siumLikutList
            case 'droppble3': return ashlamotLikutList
            case 'droppble4': return likutList
            case 'droppble5': return closedList
            default: return null
        }
    }
    const setListByCol = (col, value) => {
        switch (col) {
            case 'droppble1': setMishloahList(value); return
            case 'droppble2': setSiumLikutList(value); return
            case 'droppble3': setAshlamotLikutList(value); return
            case 'droppble4': setLikutList(value); return
            case 'droppble5': setClosedList(value); return
            default: return
        }
    }
    const saveSnapshot = () => {
        dragSnapshotRef.current = {
            mishloahList: [...mishloahList],
            siumLikutList: [...siumLikutList],
            ashlamotLikutList: [...ashlamotLikutList],
            likutList: [...likutList],
            closedList: [...closedList],
        }
    }
    const restoreSnapshot = () => {
        const s = dragSnapshotRef.current
        if (!s) return
        setMishloahList(s.mishloahList)
        setSiumLikutList(s.siumLikutList)
        setAshlamotLikutList(s.ashlamotLikutList)
        setLikutList(s.likutList)
        setClosedList(s.closedList)
    }

    const onDragStart = (event) => {
        setIsDragActive(true)
        const sourceColumn = event.active.data.current?.sortable?.containerId
        dragSourceColRef.current = sourceColumn
        saveSnapshot()
        setDroppbleAreas(() => droppableAreasHelper(sourceColumn))
        const id = String(event.active.id)
        const found = [...likutList, ...siumLikutList, ...ashlamotLikutList, ...mishloahList, ...closedList]
            .find((o) => o.OrderID?.toString() === id)
        setActiveItem(found || null)
    }
    const onDragOver = (event) => {
        const { active, over } = event
        if (!over) return
        const overContainer = over.data.current?.sortable?.containerId ?? over.id
        if (!overContainer) return
        if (Date.now() - lastCrossColMoveRef.current < 140) return

        const source = dragSourceColRef.current
        if (!source || !dragSnapshotRef.current) return
        if (overContainer === source) {
            // Rolled back to source container; reset all lists to snapshot
            lastCrossColMoveRef.current = Date.now()
            startTransition(() => {
                if (!dragSnapshotRef.current) return
                restoreSnapshot()
            })
            return
        }
        const allowed = droppableAreasHelper(source)
        if (!allowed.includes(overContainer)) return

        const colToSnap = {
            droppble1: dragSnapshotRef.current.mishloahList,
            droppble2: dragSnapshotRef.current.siumLikutList,
            droppble3: dragSnapshotRef.current.ashlamotLikutList,
            droppble4: dragSnapshotRef.current.likutList,
            droppble5: dragSnapshotRef.current.closedList,
        }

        const id = String(active.id)
        const sourceSnap = colToSnap[source]
        if (!sourceSnap) return
        const item = sourceSnap.find((i) => i.OrderID?.toString() === id)
        if (!item) return

        const destSnap = colToSnap[overContainer]
        if (!destSnap) return

        const overIndex = over.data.current?.sortable?.index
        const insertIndex = typeof overIndex === 'number' ? overIndex : destSnap.length

        const newSource = sourceSnap.filter((i) => i.OrderID?.toString() !== id)
        const newDest = [
            ...destSnap.slice(0, insertIndex),
            item,
            ...destSnap.slice(insertIndex),
        ]

        lastCrossColMoveRef.current = Date.now()
        startTransition(() => {
            // Skip if the drop already committed (onDragEnd clears the snapshot ref).
            // Otherwise this deferred update would overwrite the final state.
            if (!dragSnapshotRef.current) return
            // Reset any column that may have been mutated by a previous over-fire,
            // then apply the intended source→dest delta from snapshot.
            Object.keys(colToSnap).forEach((col) => {
                if (col !== source && col !== overContainer) {
                    setListByCol(col, colToSnap[col])
                }
            })
            setListByCol(source, newSource)
            setListByCol(overContainer, newDest)
        })
    }
    const onDragCancel = () => {
        setIsDragActive(false)
        restoreSnapshot()
        dragSnapshotRef.current = null
        dragSourceColRef.current = null
        setDroppbleAreas([])
        setActiveItem(null)
    }
    const STATUS_BY_DEST_COL = {
        droppble1: 4,
        droppble2: 3,
        droppble3: 7,
        droppble5: 9,
    }

    const onDragEnd = (event) => {
        setIsDragActive(false)
        const { active, over } = event
        setDroppbleAreas([])
        setActiveItem(null)

        const sourceCol = dragSourceColRef.current
        const snap = dragSnapshotRef.current
        dragSourceColRef.current = null
        dragSnapshotRef.current = null

        const rollback = () => {
            if (!snap) return
            setMishloahList(snap.mishloahList)
            setSiumLikutList(snap.siumLikutList)
            setAshlamotLikutList(snap.ashlamotLikutList)
            setLikutList(snap.likutList)
            setClosedList(snap.closedList)
        }

        if (!over || !sourceCol) {
            rollback()
            return
        }

        // Derive dest from `over`, not from active — under startTransition the
        // active DOM node may still be mounted in the source SortableContext at
        // drop time, so active.sortable.containerId lags behind user intent.
        const destCol = over.data.current?.sortable?.containerId ?? over.id
        const overTargetId = destCol

        if (!destCol || destCol === 'droppble4' || overTargetId === 'droppble4') {
            rollback()
            return
        }
        if (destCol === 'droppble5' && sourceCol !== 'droppble1') {
            rollback()
            return
        }

        const activeIdStr = String(active.id)

        // Snapshot-backed list accessors — using snap because under startTransition
        // the current closure state may not reflect the ephemeral onDragOver move yet.
        const colToSnap = {
            droppble1: snap.mishloahList,
            droppble2: snap.siumLikutList,
            droppble3: snap.ashlamotLikutList,
            droppble4: snap.likutList,
            droppble5: snap.closedList,
        }

        if (destCol === sourceCol) {
            const list = colToSnap[destCol]
            if (!list) return
            const overIdStr = String(over.id)
            const oldIndex = list.findIndex((i) => i.OrderID?.toString() === activeIdStr)
            const newIndex = list.findIndex((i) => i.OrderID?.toString() === overIdStr)
            if (oldIndex >= 0 && newIndex >= 0 && oldIndex !== newIndex) {
                setListByCol(destCol, arrayMove(list, oldIndex, newIndex))
            }
            return
        }

        const newStatus = STATUS_BY_DEST_COL[destCol]
        if (newStatus === undefined) {
            rollback()
            return
        }

        const sourceListSnap = colToSnap[sourceCol]
        const destListSnap = colToSnap[destCol]
        if (!sourceListSnap || !destListSnap) {
            rollback()
            return
        }
        const movedItem = sourceListSnap.find((i) => i.OrderID?.toString() === activeIdStr)
        if (!movedItem) {
            rollback()
            return
        }
        const changeStatus = { ...movedItem, Status: newStatus }

        const overIndex = over.data.current?.sortable?.index
        const destInsertIdx = typeof overIndex === 'number' ? overIndex : destListSnap.length

        // Rebuild source (minus item) and dest (plus status-changed item) from snapshot.
        setListByCol(sourceCol, sourceListSnap.filter((i) => i.OrderID?.toString() !== activeIdStr))
        setListByCol(destCol, [
            ...destListSnap.slice(0, destInsertIdx),
            changeStatus,
            ...destListSnap.slice(destInsertIdx),
        ])
        // Reset any other column that the ephemeral onDragOver may have mutated.
        Object.keys(colToSnap).forEach((col) => {
            if (col !== sourceCol && col !== destCol) {
                setListByCol(col, colToSnap[col])
            }
        })

        const updatedDefault = azmanotListDefault.map((item) =>
            item.OrderID === changeStatus.OrderID ? changeStatus : item
        )
        const updatedCur = azmanotList.map((item) =>
            item.OrderID === changeStatus.OrderID ? changeStatus : item
        )

        if (destCol === 'droppble5') {
            let carID = transportAreaDict[changeStatus.TransferZone]?.CarId
            if (!carID) {
                if (isHovaRehev) {
                    if (defaultCarID !== 0) {
                        carID = defaultCarID
                    } else {
                        setTempTeudaData({
                            dataForTeuda: {
                                PalletNums: [],
                                OrderNum: changeStatus.OrderID,
                                CustomerID: changeStatus.CustomerID,
                                DeliveryDate: changeStatus.Delivery_Date,
                                DeliveryTime: '',
                                Tranzit: resolveTeudaTranzit(user?.tranzit, customersDict[changeStatus?.CustomerID]?.PickupWarehouse, getBrodMigdal({ id: 5 })),
                                Vehicle_Code: carID || 0,
                            },
                            curOrdersList: updatedCur,
                            defOrdersList: updatedDefault,
                        })
                        handleNotifications('חובה לבחור רכב', { type: 'warning' })
                        setIsOpenSelectDriver(true)
                        return
                    }
                }
            }
            const dataForTeuda = {
                PalletNums: [],
                OrderNum: changeStatus.OrderID,
                CustomerID: changeStatus.CustomerID,
                DeliveryDate: changeStatus.Delivery_Date,
                DeliveryTime: '',
                Tranzit: resolveTeudaTranzit(user?.tranzit, customersDict[changeStatus?.CustomerID]?.PickupWarehouse, getBrodMigdal({ id: 5 })),
                Vehicle_Code: carID || 0,
            }
            const res = createTeuda(dataForTeuda)
            if (res?.status === 404) return
            setAzmanotList(updatedCur)
            setAzmanotListDefault(updatedDefault)
            return
        }

        setAzmanotList(updatedCur)
        setAzmanotListDefault(updatedDefault)
        changeStatusAzmana(changeStatus.OrderID, changeStatus.Status)
        if (destCol === 'droppble3' && sourceCol !== 'droppble5') {
            putWorkersAzmanot(changeStatus.WorkerID, changeStatus)
        }
    }

    const scroller = () => {
        if (scrollFlag) {
            setScrollFlag(false);
            scrollRef?.current?.scrollIntoView({
                behavior: 'smooth'
            })
        } else {
            setScrollFlag(true);
            scrollRef?.current?.scrollIntoView({
                behavior: 'smooth'
            })
        }
    }

    const createTeuda = async (data) => {
        setRequestCounter(prev => prev + 1)
        try {
            let res = await Certificates.createCert(data)
            setClosedList(prev => prev.map(e => {
                if (e.OrderID === data.OrderNum) {
                    e.teudot.push({
                        ...res
                    })
                }
                return e
            }))
            changeStatusAzmana(data.OrderNum, 9)
            return true
        } catch (err) {
            console.log(err.response)
            if(err.response.status === 404) {
                changeStatusAzmana(data.OrderNum, 9)
                return
            }
            handleNotifications(err.response.data.message, { type: 'error' })
        } finally {
            setRequestCounter(prev => prev - 1)
        }
    }
    const printPdf = useCallback(async (CODE, SUBCODE) => {
        dispatch({ type: LOAD })
        try {
            const blob = await Printouts.getTeudaPdf(CODE, SUBCODE)
            setPdfFromBlob(blob, `תעודה-${CODE}-${SUBCODE}.pdf`)
            dispatch({ type: LOAD_END });
        } catch (err) {
            dispatch({ type: LOAD_END });
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        }
    }, [dispatch, setPdfFromBlob])

    const [isOpenPalletDetailes, setIsOpenPalletDetailes] = useState(false)
    const [palletDetailesListForModal, setPalletDetailesListForModal] = useState([])
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isOpenOrderStatusLog, setIsOpenOrderStatusLog] = useState(false);
    const {
        data: paletTypes
      } = useDataFetcher(
        Defaults.getPalletTypes, 'data'
      )
    const handlePalletDetailsModal = useCallback(() => {
        setIsOpenPalletDetailes(prev => !prev)
    }, [])
    const getPalletDetailesByOrder = useCallback((IOrderTitleItem) => {
        setSelectedOrder(IOrderTitleItem)
        handlePalletDetailsModal()
    }, [handlePalletDetailsModal])

   
    const packagePalletProps = {
        order: selectedOrder,
    }

    useEffect(() => {
        getCars()
        scroller()
    }, [])

    const selectOrderStatusForShow = (id) => {
        setVisibleColumns({
            ...visibleColumns,
            [id]: !visibleColumns[id]
        })
    }
    const selectDriverP = {
        saveFunc: patchDriver,
        list: carsInfo
    }
    const remarkWindowProps = {
        data: remarkWindowData,
        isActive: false
      }
    const orderStatusLogProps = {
        orderId: selectedOrder?.OrderID || 0
    }
    const handleOrderStatusLogModal = useCallback(() => {
        setIsOpenOrderStatusLog(prev => !prev)
    }, [])
    const handleOpenOrderStatusLogModal = useCallback((order) => {
        setSelectedOrder(order)
        handleOrderStatusLogModal()
    }, [handleOrderStatusLogModal])
    const [isOpenWorkerHistory, setIsOpenWorkerHistory] = useState(false)
    const handleWorkerHistoryModal = useCallback(() => {
        setIsOpenWorkerHistory(prev => !prev)
    }, [])
    const handleOpenWorkerHistoryModal = useCallback((order) => {
        setSelectedOrder(order)
        handleWorkerHistoryModal()
    }, [handleWorkerHistoryModal])
    // console.log(azmanotList)
    const handleDroppableArea = useCallback((id) => {
        return droppbleAreas.includes(id)
    }, [droppbleAreas])

    const sensors = useSensors(
        useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
        useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 8 } }),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
    )

    const dragOverlayCard = useMemo(() => {
        if (!activeItem) return null
        return (
            <OrderGetheringItemWithDetailes
                {...activeItem}
                Color={customersDict[activeItem.CustomerID]?.Color || '#000'}
                index={0}
                isWeightCalculation={isWeightCalculation}
                workersList={workersList}
                selectIconForPalletType={selectIconForPalletType}
                deliveryCodes={deliveryCodes}
                selectProductForRemark={selectItemForRemark}
                item={activeItem}
                handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
            />
        )
    }, [activeItem, customersDict, workersList, deliveryCodes, isWeightCalculation, selectIconForPalletType, selectItemForRemark, handleOpenOrderStatusLogModal])

    return (
        <SectionMain>
            {pdfFile && (
                <AppModal
                    size='lg'
                    title='תצוגה מקדימה'
                    controlFunc={handleClearPdfFile}
                    Children={PdfPreview}
                    childrenProps={{
                        file: pdfFile,
                        handleSharePdf,
                        handleDownloadPdf,
                        handleClearFile: handleClearPdfFile,
                        handleOpenPdf,
                    }}
                />
            )}
            {
                isOpenPalletLogModal &&
                <ColumModal
                    title='לוג ליקוט'
                    Children={PalletLogModal}
                    controlFunc={handleClosePalletLogModal}
                    childrenProps={{
                        teudaNum: selectedTeuda?.Delivery_Num || 0,
                        teudaSub: selectedTeuda?.Delivery_Sub || 0,
                        orderNum: selectedTeuda?.Order_Num || 0
                    }}
                />
            }
            {
                isOpenOrderStatusLog &&
                <ColumModal
                    title='היסטוריית סטטוסים'
                    childrenProps={orderStatusLogProps}
                    Children={OrderStatusLogModal}
                    controlFunc={handleOrderStatusLogModal}
                />
            }
            {
                isOpenWorkerHistory &&
                <AppModal
                    size='md'
                    title='היסטוריית שיוך מלקטים'
                    childrenProps={{ orderId: selectedOrder?.OrderID || 0 }}
                    Children={WorkerHistoryModal}
                    controlFunc={handleWorkerHistoryModal}
                />
            }
            {
                isOpenPalletDetailes &&
                <ColumModal 
                    title='סיכום משטחים ואריזות'
                    childrenProps={packagePalletProps}
                    Children={PackagePalletSummaryModal}
                    controlFunc={handlePalletDetailsModal}
                />
            }
            {isOpenRemarkWindow && (
                <ColumModal
                title={remarkWindowData?.title || ""}
                Children={RemarkModal}
                controlFunc={handleRemarkModal}
                childrenProps={remarkWindowProps}
                />
            )}
            {
                isOpenSelectDriver &&
                    <ColumModal 
                        size='md'
                        title='בחר נהג'
                        controlFunc={cancelFuncTeudot}
                        Children={SelectDriver}
                        childrenProps={selectDriverP}
                    />
            }
            {
                isOpenSelectWorker &&
                <SelectWorkerModal
                    controlFunc={controlSelectWorkerBtn}
                    title={selectedOrderForWorker.OrderID}
                    data={workersArr}
                    putWorkersAzmanot={putWorkersAzmanot}
                    order={selectedOrderForWorker}
                    saveFunc={handleSaveWorker}
                />
            }
            <SectionMainContainer >
                <Title label={requestCounter > 0 ? `בתהליך ${requestCounter}`: 'בקרה'} color={'#297f76'} />
                <HeadWrapper style={{ width: '100%' }}>
                    <DatePickerModule
                        setSelectedDateStart={setStartDate}
                    />
                    {
                        isExistErrorRow ?
                            <ErrorWrapper>
                                <ErrorIcon />
                            </ErrorWrapper>
                            : ''
                    }
                    <FilterIndicator
                        onClick={handleModalOrders}
                    >
                        <ButtonWrapper >
                            <ProblemIndicator $visible={isExistErrorRow} />
                            {!isOpenOrderFilter ? <FilterIcon /> : <CloseIcon />}
                        </ButtonWrapper>
                    </FilterIndicator>
                    <FilterModal
                        isOpenOrderFilter={isOpenOrderFilter}
                        workerGroupList={workerGroupList}
                        deliveryCodeList={deliveryCodeList}
                        setIsOpenOrderFilter={setIsOpenOrderFilter}
                        azmanotListDefault={azmanotListDefault}
                        listSetter={listSetter}
                        setAzmanotList={setAzmanotList}
                        searchSium={searchSium}
                        siumInputValue={siumInputValue}
                        prodTypes={prodTypes}
                        customerList={customerList}
                        marketAreaList={marketAreaList}
                        isExistErrorRow={isExistErrorRow}
                        setFilterFunc={setFilterFunc}
                        customersDict={customersDict}
                        customerGroup={customerGroup}
                        warehouseList={warehouseList}
                        warehouseID={warehouseID}
                        setWarehouseID={setWarehouseID}
                    />
                    <SelectOrderToShow
                        controlFunc={selectOrderStatusForShow}
                        data={ordersAll}
                        state={visibleColumns}

                    />
                    <FilterIndicator
                        onClick={() => {
                            getAzmanot(startDate)
                        }}
                    >
                        <ButtonWrapper>
                            <ReloadIcon />
                        </ButtonWrapper>
                    </FilterIndicator>
                    <SearchInput setInput={searchSium} input={siumInputValue} value={"חיפוש"} />

                </HeadWrapper>
                <ControlLeft $visible={scrollFlag} onClick={scroller}><ArrowIcon position={'left'} /></ControlLeft>
                <ControlRigth $visible={scrollFlag} onClick={scroller}><ArrowIcon /></ControlRigth>
                <DndContext
                    sensors={sensors}
                    collisionDetection={monitoringCollisionDetection}
                    autoScroll={false}
                    // useDndAutoScroll moves BodyContainerCustom horizontally
                    // during drag; default 'WhileDragging' caches droppable
                    // rects at drag start, so an empty column at the far end
                    // of the ribbon stops accepting drops once you scroll to
                    // it. 'Always' keeps rects in sync each tick.
                    measuring={{ droppable: { strategy: MeasuringStrategy.Always } }}
                    onDragStart={onDragStart}
                    onDragOver={onDragOver}
                    onDragEnd={onDragEnd}
                    onDragCancel={onDragCancel}
                >
                    <BodyContainerCustom ref={monitoringScrollRef}>
                        <MonitoringColumn
                            id="droppble4"
                            title="ליקוט"
                            items={likutList}
                            isAllowDrop={handleDroppableArea('droppble4')}
                            visible={visibleColumns['1']}
                            columnRef={scrollFlag ? scrollRef : null}
                            customersDict={customersDict}
                            workersList={workersList}
                            deliveryCodes={deliveryCodes}
                            isWeightCalculation={isWeightCalculation}
                            selectIconForPalletType={selectIconForPalletType}
                            selectProductForRemark={selectItemForRemark}
                            handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                            handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                        />
                        <MonitoringColumn
                            id="droppble2"
                            title="סיום ליקוט"
                            items={siumLikutList}
                            isAllowDrop={handleDroppableArea('droppble2')}
                            visible={visibleColumns['3']}
                            customersDict={customersDict}
                            workersList={workersList}
                            deliveryCodes={deliveryCodes}
                            isWeightCalculation={isWeightCalculation}
                            selectIconForPalletType={selectIconForPalletType}
                            selectProductForRemark={selectItemForRemark}
                            handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                            handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                        />
                        <MonitoringColumn
                            id="droppble3"
                            title="השלמות"
                            items={ashlamotLikutList}
                            isAllowDrop={handleDroppableArea('droppble3')}
                            visible={visibleColumns['7']}
                            customersDict={customersDict}
                            workersList={workersList}
                            deliveryCodes={deliveryCodes}
                            isWeightCalculation={isWeightCalculation}
                            selectIconForPalletType={selectIconForPalletType}
                            selectProductForRemark={selectItemForRemark}
                            handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                            handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                            actionFunc={controlSelectWorkerBtn}
                        />
                        <MonitoringColumn
                            id="droppble1"
                            title="מוכנה למשלוח"
                            items={mishloahList}
                            isAllowDrop={handleDroppableArea('droppble1')}
                            visible={visibleColumns[4]}
                            customersDict={customersDict}
                            workersList={workersList}
                            deliveryCodes={deliveryCodes}
                            isWeightCalculation={isWeightCalculation}
                            selectIconForPalletType={selectIconForPalletType}
                            selectProductForRemark={selectItemForRemark}
                            handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                            handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                            handlePalletDetailsModal={getPalletDetailesByOrder}
                        />
                        <MonitoringColumn
                            id="droppble5"
                            title="תעודות"
                            items={closedList}
                            isAllowDrop={handleDroppableArea('droppble5')}
                            visible={visibleColumns[9]}
                            columnRef={!scrollFlag ? scrollRef : null}
                            customersDict={customersDict}
                            workersList={workersList}
                            deliveryCodes={deliveryCodes}
                            isWeightCalculation={isWeightCalculation}
                            selectIconForPalletType={selectIconForPalletType}
                            selectProductForRemark={selectItemForRemark}
                            handleOpenOrderStatusLogModal={handleOpenOrderStatusLogModal}
                            handleOpenWorkerHistoryModal={handleOpenWorkerHistoryModal}
                            actionFunc={printPdf}
                            handlePalletDetailsModal={getPalletDetailesByOrder}
                            selectTeudaFunc={selectTeudaFunc}
                            handleOpenPalletLogModal={handleOpenPalletLogModal}
                        />
                    </BodyContainerCustom>
                    <DragOverlay dropAnimation={{ duration: 200, easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)' }}>
                        {dragOverlayCard}
                    </DragOverlay>
                </DndContext>
            </SectionMainContainer>
        </SectionMain>
    )
}


const reduceArrayForHashTable = (arr, key, value, valueType = 'string') => {
    let reducedArr = arr.reduce((acc, cur) => {
        if (valueType === 'arr') {
            // console.log(cur[key])
            acc[cur[key]] = acc[cur[key]]?.concat(cur) || [].concat(cur)
        }
        else {
            acc[cur[key]] = cur[value]?.trim()
        }
        return acc

    }, {})
    return reducedArr
}